import styles from './EarlyPurchase.module.scss';
import Typography from '../../Typography';
import TextInput from '../../TextInput';
import GradeInput from '../../GradeInput';
import Button from '../../Button';
import React, { useContext, useEffect, useState } from 'react'
import { CustomerContext } from '../../../contexts/CustomerContext'
import { useHistory } from 'react-router-dom'
import { Student } from '../../../models'
import { School, SchoolType } from '../../../models/_models'
import Select from 'react-select'
import routes from '../../../routes';
import useQueryString from '../../../hooks/use-query-string';
import axios from 'axios';

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? '#000' : '#777',
    fontFamily: 'inherit',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#777',
    fontFamily: 'inherit',
    fontSize: '0.95em',
  }),
}

export default function Form() {
  const { customer, setCustomer } = useContext(CustomerContext)
  const history = useHistory()
  const { app, o: isOther, p, order } = useQueryString()

  const [studentId, setStudentId] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [grade, setGrade] = useState('')
  const [teacher, setTeacher] = useState('')
  const [teachers, setTeachers] = useState([])
  const [isHighSchool, setIsHighSchool] = useState(false)

  const isYearbookOrder = order === 'yearbook_order'

  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    axios.get(`/students/teachers?school_id=${customer.currentSchool.id}`)
      .then((res) => {
        const newTeachers = res
          .data.data
          .map(({ teacher: resTeacher }) => resTeacher)
          .filter((teacherName) => teacherName && teacherName.length > 0)

        setTeachers([...new Set(newTeachers)])
      })
  }, [])

  useEffect(() => {
    if (customer.currentSchool.schoolTypeId) {
      SchoolType
        .find(customer.currentSchool.schoolTypeId)
        .then((res) => {
          setIsHighSchool(res.data.name === 'High School')
        })
    } else {
      School
        .find(customer.currentSchool.id)
        .then((res) => {
          SchoolType
            .find(res.data.schoolTypeId)
            .then((schoolTypeRes) => {
              setIsHighSchool(schoolTypeRes.data.name === 'High School')
            })
        })
    }
  }, [])

  const onSubmit = (e) => {
    e.preventDefault()

    setSubmitting(true)

    const queryParams = {
      firstName: { match: firstName },
      lastName: { match: lastName },
      schoolId: customer.currentSchool.id,
      grade,
    }

    const studentIdParam = studentId ? { studentId } : {}

    Student
      .where({ ...queryParams, ...studentIdParam })
      .all()
      .then((res) => {
        // if there are too many or no results that match, then make a new student
        if (res.data.length > 1 || res.data.length === 0) {
          const newStudent = new Student({
            firstName,
            lastName,
            grade,
            teacher,
            studentId,
            schoolId: customer.currentSchool.id,
          })

          newStudent.save().then(() => {
            setCustomer({ ...customer, currentStudent: newStudent })
            if (isYearbookOrder) {
              history.push(routes.yearbooks({ sid: newStudent.studentId, sch: customer.currentSchool.id }))
            } else {
              history.push('package_selection?preorder=true')
            }
          })
        } else {
          setCustomer({ ...customer, currentStudent: res.data[0] })
          if (isYearbookOrder) {
            history.push(routes.yearbooks({ sid: res.data[0].studentId, sch: customer.currentSchool.id }))
          } else {
            history.push('package_selection?preorder=true')
          }
        }
      })
  }

  return (
    <form onSubmit={onSubmit} className={styles.container}>
      <div>
        <Typography weight="bold" align="center" classes={styles.shoobBlueText}>
          Please enter your student information to continue
        </Typography>
      </div>
      <TextInput
        fullWidth
        val={studentId}
        label="Student ID (optional)"
        onChange={(e) => setStudentId(e.target.value)}
      />
      <TextInput
        required
        fullWidth
        val={firstName}
        label="First Name"
        onChange={(e) => setFirstName(e.target.value)}
      />
      <TextInput
        required
        fullWidth
        val={lastName}
        label="Last Name"
        onChange={(e) => setLastName(e.target.value)}
      />
      <label>
        <label style={{ fontSize: '0.8em', marginLeft: '14px' }}>Grade</label>
        <GradeInput
          required
          val={grade}
          onChange={(val) => setGrade(val)}
        />
      </label>
      {!isHighSchool && grade !== 'STAFF' && (
        <>
          {/*{teachers.length > 0 ? (*/}
          {/*  <>*/}
          {/*    <label style={{ fontSize: '0.8em', marginLeft: '14px', marginBottom: '-20px' }}>Teacher's Name</label>*/}
          {/*    <Select*/}
          {/*      defaultValue={teachers[0]}*/}
          {/*      styles={customStyles}*/}
          {/*      options={teachers*/}
          {/*        .map((teacherName) => ({ value: teacherName, label: teacherName }))}*/}
          {/*      onChange={(e) => setTeacher(e.value)}*/}
          {/*    />*/}
          {/*  </>*/}
          {/*) : (*/}
          <TextInput
            required
            fullWidth
            val={teacher}
            label="Teacher's Last Name"
            onChange={(e) => setTeacher(e.target.value)}
          />
          {/*)}*/}
        </>
      )}
      <Button disabled={submitting} type="submit" fullWidth variant="submit">
        Continue
      </Button>
    </form>
  )
}
